document.addEventListener('DOMContentLoaded', function () {

  const searchModalDetails = document.querySelector('.header__icons .header__search details');
  const searchInput = document.querySelector('.header__icons .search__input');
  const predictiveSearchContainer = document.querySelector('[data-predictive-search]');
  const recommendedSearch = document.querySelector('.header__icons .recommended-search');

  if (searchModalDetails && searchInput && predictiveSearchContainer && recommendedSearch) {

    function showRecommended(inputEl, recEl, predEl) {
      recEl.style.display = 'block';
      predEl.style.display = 'none';
      inputEl.setAttribute('aria-expanded', 'true');
    }

    function showPredictive(inputEl, recEl, predEl) {
      predEl.style.display = 'block';
      recEl.style.display = 'none';
      inputEl.setAttribute('aria-expanded', 'true');
    }

    function hideAll(inputEl, recEl, predEl) {
      recEl.style.display = 'none';
      predEl.style.display = 'none';
      inputEl.setAttribute('aria-expanded', 'false');
    }

    searchModalDetails.addEventListener('toggle', function () {
      if (searchModalDetails.open) {
        searchInput.focus();
        if (searchInput.value.trim() === '') {
          showRecommended(searchInput, recommendedSearch, predictiveSearchContainer);
        }
      } else {
        hideAll(searchInput, recommendedSearch, predictiveSearchContainer);
      }
    });

    searchInput.addEventListener('focus', function () {
      if (searchModalDetails.open && searchInput.value.trim() === '') {
        showRecommended(searchInput, recommendedSearch, predictiveSearchContainer);
      }
    });

    searchInput.addEventListener('input', function () {
      if (searchInput.value.trim() === '') {
        showRecommended(searchInput, recommendedSearch, predictiveSearchContainer);
      } else {
        showPredictive(searchInput, recommendedSearch, predictiveSearchContainer);
      }
    });

    searchInput.addEventListener('blur', function () {
      setTimeout(() => hideAll(searchInput, recommendedSearch, predictiveSearchContainer), 200);
    });
  }

  const mobileSearchBox = document.querySelector('.mobile_search_input_box');
  
  if (mobileSearchBox) {
    const mobileInput = mobileSearchBox.querySelector('.search__input');
    const mobilePredictive = mobileSearchBox.querySelector('[data-predictive-search]');
    const mobilerecommendedSearch = mobileSearchBox.querySelector('.recommended-search');


    if (mobileInput && mobilePredictive) {

      mobileInput.addEventListener('focus', function () {
        if (mobileInput.value.trim() === '') {
          showRecommended(mobileInput, mobilerecommendedSearch, mobilePredictive);
        }
      });

      mobileInput.addEventListener('input', function () {
        if (mobileInput.value.trim() === '') {
          showRecommended(mobileInput, mobilerecommendedSearch, mobilePredictive);
        } else {
          showPredictive(mobileInput, mobilerecommendedSearch, mobilePredictive);
        }
      });

      mobileInput.addEventListener('blur', function () {
        setTimeout(() => hideAll(mobileInput, mobilerecommendedSearch, mobilePredictive), 200);
      });
    }
  }

});
